export const DESKTOP_BREAKPOINTS = {
    '809': 5,
    '704': 4,
    '0': 4
};

export const MOBILE_BREAKPOINTS = {
    '735': 3.3,
    '0': 3.3
};
